import React, { createContext, useContext, useState } from 'react';

const SidebarContext = createContext(undefined);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const [expandedItem, setExpandedItem] = useState("/account-management");
  const sidebarScrollPos = React.useRef(0);

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
  };

  const setSidebarOpen = (open) => {
    setIsSidebarOpen(open);
  };

  return (
    <SidebarContext.Provider value={{
      isSidebarOpen,
      toggleSidebar,
      setSidebarOpen,
      expandedItem,
      setExpandedItem,
      sidebarScrollPos
    }}>
      {children}
    </SidebarContext.Provider>
  );
};